import {Query} from "appwrite";
import {SchedulePeriod} from "../types";
import {Dayjs} from "dayjs";

type BuildOperationTimeQueriesProps = {
  period: SchedulePeriod
  selectedDate: Dayjs
}

export const buildOperationTimeQueries = (
  props: BuildOperationTimeQueriesProps,
) => {
  const {period, selectedDate} = props

  if (period === 'day') {
    return [
      Query.greaterThanEqual(
        'operationTime',
        selectedDate.startOf('day').toISOString(),
      ),
      Query.lessThanEqual(
        'operationTime',
        selectedDate.endOf('day').toISOString(),
      ),
    ]
  }

  if (period === 'week') {
    return [
      Query.greaterThanEqual(
        'operationTime',
        selectedDate.startOf('week').toISOString(),
      ),
      Query.lessThanEqual(
        'operationTime',
        selectedDate.endOf('week').toISOString(),
      ),
    ]
  }

  return [
    Query.greaterThanEqual(
      'operationTime',
      selectedDate.startOf('month').toISOString(),
    ),
    Query.lessThanEqual(
      'operationTime',
      selectedDate.endOf('month').toISOString(),
    ),
  ]
}